







import Vue from 'vue'
import { Block2TextElInterface } from '@/config/interfaces'
import { darkColors, lightColors } from '@/config/colors'

export default Vue.extend({
  name: 'Block2TextEl',
  props: {
    templateItemData: {
      type: Object as () => Block2TextElInterface,
      required: true
    }
  },
  computed: {
    getTextColor (): string {
      return `color: ${this.$props.templateItemData.textColor || (this.$props.templateItemData.background
        ? lightColors.primary : darkColors.textColor)};`
    }
  }
})
